'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CarouselNavIndexContextProvider: function() {
        return CarouselNavIndexContextProvider;
    },
    carouselNavIndexContextDefaultValue: function() {
        return carouselNavIndexContextDefaultValue;
    },
    useCarouselNavIndexContext: function() {
        return useCarouselNavIndexContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const carouselNavIndexContext = /*#__PURE__*/ _react.createContext(undefined);
const carouselNavIndexContextDefaultValue = 0;
const useCarouselNavIndexContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(carouselNavIndexContext)) !== null && _React_useContext !== void 0 ? _React_useContext : carouselNavIndexContextDefaultValue;
};
const CarouselNavIndexContextProvider = carouselNavIndexContext.Provider;
